let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("e7Kqr")]).then(() => parcelRequire('bnCpk'));